import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AiBattle from "./pages/AiBattle";
import "./App.css";
import UserBattle from "./pages/UserBattle";
import Login from "./components/user/Login";
import Leaderboard from "./components/user/Leaderboard";

const App = () => (
  <Router>
    <Routes>
      {/* Redirect from root to /user */}
      <Route path="/" element={<Navigate to="/ai" replace />} />
      {/* Route for UserBattle */}
       <Route path="login" element={<Login />} />
      <Route path="/ai/*" element={<AiBattle />} />
      <Route path="/user/*" element={<UserBattle />} />
       <Route path="leaderboard" element={<Leaderboard />} />
    </Routes>
  </Router>
);

export default App;
